<template>
 
    <div class="app-breadcrumb">
      <span style="display:inline-block; margin-right: 30px;">登录用户:{{name}}   </span>
      <span class="cl-logout-button" @click="logout"><i class="el-icon-switch-button"></i></span>
    </div>
  
      
  
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'name'
    ])
  },
  methods: {
    logout: function () {
      this.$store.dispatch('logout').then(res => {
        window.console.log('logout...')
        // has bug, if go / and error
        this.$router.push('/login')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 20px;
  margin-left: 8px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>

